const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTypeConditional(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5.7113mm",
    height: "5.8306mm",
    viewBox: "0 0 5.7113 5.8306",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-65.214 -144.74)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.01 .80263)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 78.08 146.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m76.926 144.4h.41484c.31316 0 .48554.30704.48554.55374v1.5455h1.4065",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.2,
      stroke: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.99 145.8.61687.69943-.61687.69943",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 0.2,
      stroke: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.926 148.6h.41484c.31316 0 .48554-.30704.48554-.55374v-1.5455h1.7807",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.2,
      stroke: "#000000"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 75.98,
    cy: 144.69,
    r: 0.65614,
    style: {
      fill: "none",
      paintOrder: "stroke markers fill",
      strokeDashoffset: 11.411,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.2,
      stroke: "#000000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.179,
    cy: 144.69,
    r: 0.65614,
    style: {
      fill: "none",
      paintOrder: "stroke markers fill",
      strokeDashoffset: 11.411,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.2,
      stroke: "#000000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.08,
    cy: 149.01,
    r: 0.65614,
    style: {
      fill: "none",
      paintOrder: "stroke markers fill",
      strokeDashoffset: 11.411,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.2,
      stroke: "#000000"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeConditional);
export default __webpack_public_path__ + "static/media/icon_type_conditional.deb4e8629e6066f48ae3c58ff6dc6dd1.svg";
export { ForwardRef as ReactComponent };